import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

import { inputEventHandler } from '../../../utils/component/inputEventHandler';

type PhoneNumberDisabledInputProps = {
  inputLabelKey: string;
  inputProps?: Record<string, unknown>;
  value: string;
};

/**
 * PhoneNumberDisabledInput
 *
 * A disabled version of the PhoneNumberInput component. Used to display a phone number that cannot be edited.
 */
export const PhoneNumberDisabledInput = ({
  inputLabelKey,
  inputProps,
  value,
}: PhoneNumberDisabledInputProps) => {
  const { t } = useTranslation();

  const defaultValue = inputEventHandler.phoneNumber.formatter(value);

  return (
    <TextField
      defaultValue={defaultValue}
      inputProps={inputProps}
      label={t(inputLabelKey)}
      style={{ pointerEvents: 'none' }}
      variant="outlined"
      disabled
      fullWidth
    />
  );
};
